import PresetSelector from '@/components/datagrid/PresetSelector';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import IntegrationInstructionsRoundedIcon from '@mui/icons-material/IntegrationInstructionsRounded';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

import {
  GridToolbar,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid-premium';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getSelectedAccount } from '@/redux/selectedAccountSlice';

import { Box, Button, Grow, InputAdornment, Tooltip } from '@mui/material';
import HeatingPanicButton from '../HeatingPanicButton';

const BuildingDataGridToolbar = ({ onCreateBuilding, ...props }) => {
  const [showToolbar, setShowToolbar] = useState(false);
  const navigate = useNavigate();
  const account = useSelector(getSelectedAccount);
  return (
    <GridToolbarContainer
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 1,
        background: 'inherit',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <GridToolbarQuickFilter
          size="small"
          sx={{
            '& .MuiInputBase-root': {
              backgroundColor: (theme) => theme.palette.background.paper,
              borderRadius: 2,
            },
            '& .MuiFilledInput-root': {
              borderRadius: '5px',
            },
            '& .MuiInput-underline:before, & .MuiInput-underline:after': {
              display: 'none',
            },
            '& .MuiInputLabel-root': {
              color: 'gray',
            },
          }}
          variant="outlined"
          InputProps={{
            placeholder: 'Søg bygninger...',
            startAdornment: (
              <InputAdornment position="start">
                <SearchRoundedIcon sx={{ color: 'gray' }} />
              </InputAdornment>
            ),
          }}
        />
        <Button
          startIcon={<IntegrationInstructionsRoundedIcon />}
          endIcon={<ArrowForwardRoundedIcon />}
          variant="outlined"
          onClick={() => navigate('/PVO/subscriptions')}
          sx={{
            mx: 1,
            borderRadius: 2,
            borderColor: 'divider',
            backgroundColor: 'background.paper',
            textTransform: 'none',
            p: 0.9,
            mt: -0.5,
            color: 'text.primary',
            ':hover': {
              borderColor: 'divider',
            },
          }}
        >
          Gå til subscriptions
        </Button>
        <PresetSelector {...props} />
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <>
          <Grow in={showToolbar}>
            <GridToolbar />
          </Grow>

          <Tooltip
            title={showToolbar ? 'Hide Options' : 'Show Options'}
            placement="top"
          >
            <Button
              startIcon={
                showToolbar ? <FilterListOffIcon /> : <FilterListIcon />
              }
              variant="outlined"
              size="small"
              onClick={() => setShowToolbar(!showToolbar)}
              sx={{
                borderRadius: 2,
                borderColor: 'divider',
                backgroundColor: 'background.paper',
                textTransform: 'none',
                p: 0.9,
                mt: -0.5,
                color: 'text.primary',
              }}
            >
              {showToolbar ? 'Skjul indstillinger' : 'Vis indstillinger'}
            </Button>
          </Tooltip>
        </>
        <HeatingPanicButton accountId={account?.AccountId} />
        <Button
          startIcon={<AddRoundedIcon />}
          variant="contained"
          onClick={onCreateBuilding}
          sx={{ mt: -0.5 }}
        >
          Ny bygning
        </Button>
      </Box>
    </GridToolbarContainer>
  );
};

export default BuildingDataGridToolbar;
